<template>
  <div class="research-mode">
    <div class="model"></div>
    <div class="content" :style="'bottom:'+position.y+'rem;'">
      <canvas width="500" height="500" ref="yj" style="width:90%;"></canvas>
      <div class="yj-text">当前模式：研究模式</div>
      <div class="searchButton">
        <div class="button-item oncemore" @click.stop="researchAgain">重来</div>
        <div class="button-item" @click.stop="prevStep">上一步</div>
        <div class="button-item" @click.stop="nextStep">下一步</div>
      </div>
      <div class="backButton" @click.stop="goBackNormal">返回正常模式</div>
    </div>
  </div>
</template>

<script>
import Island from '../lib/island';

export default {
  name: 'researchMode',
  props: {
    desc: {
      type: String,
      default: '',
    },
    position: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      status: 1, // 步数
    };
  },
  mounted() {
    this.yj();
  },
  methods: {
    invitationRegister() {
      this.$router.push('/invitation');
    },
    // 研究
    yj() {
      const { Resource } = Island;
      window.res = new Resource({
        $el: this.$refs.yj, // canvas对象
        sz: 11, // 棋盘大小
        width: 500, // canvas宽度
        content: this.desc, // 可填内容，如果没有填从空开始
        /** status
         * @object code 1 第一步，code 2 最后一步
         * @object message 提示信息
         */
        // let status = window.res.goStep(1); // 1代表前进一步，-1代表后退一步
      });
    },
    // 重新加载
    reload() {
      window.res.off();
      this.yj();
    },
    goStep(step) {
      window.res.goStep(step);
    },
    // 返回正常模式
    goBackNormal() {
      console.log('back');
      this.$emit('closeResearchMode');
    },
    // 重来
    researchAgain() {
      // this.yj();
      this.reload();
    },
    // 下一步
    nextStep() {
      const status = window.res.goStep(1);
      if (status && status.code === 2) {
        this.$toast(status.message);
      }
    },
    // 上一步
    prevStep() {
      const status = window.res.goStep(-1);
      if (status && status.code === 1) {
        this.$toast(status.message);
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .research-mode{
    padding: 0;
    margin:0;
    width: 100%;
    height: 100%;
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    .model{
      padding: 0;
      margin:0;
      width: 100%;
      height: 100%;
      position: fixed;
      top:0;
      left:0;
      right:0;
      bottom:0;
      background: #000;
      opacity: 0.7;
      z-index:9;
    }
    .content{
      width:80%;
      z-index:9;
      background: #fff4da;
      position: absolute;
      text-align:center;
      width:halvePx(600);
      height: auto;
      padding:halvePx(20) 0;
      left:50%;
      transform: translate(-50%);
      .yj-text{
        font-size:halvePx(30);
        font-family:PingFang-SC-Medium;
        font-weight:500;
        color:rgba(160,140,94,1);
        text-align:center;
        margin:halvePx(40) auto;
      }
      .searchButton{
        display: flex;
        align-items: center;
        justify-content:space-around;
        .button-item{
          width:halvePx(160);
          height:halvePx(100);
          line-height:halvePx(100);
          text-align:center;
          background:rgba(244,229,194,1);
          border-radius:halvePx(8);
          font-size:halvePx(30);
          font-family:PingFang-SC-Medium;
          font-weight:500;
          color:#A08C5E;
        }
        .oncemore{
          background: #FD7979;
          color:#fff;
        }
      }
      .backButton{
        width:halvePx(540);
        height:halvePx(100);
        line-height:halvePx(100);
        text-align:center;
        background:#7db9ff;
        border-radius:halvePx(8);
        font-size:halvePx(30);
        font-family:PingFang-SC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        margin:halvePx(20) auto;
      }
    }
  }
</style>
